<template>
    <div>
        <a
            href="#"
            class="btn btn-md is-ghost mb-lg md:mb-0 md:ml-lg"
            @click="$modal.show('editMailshotModal')"
        >
            Redigera mottagarlista
        </a>
        <adaptive-form-modal
            :name="'editMailshotModal'"
            primary-button-text="Ta bort valda mottagare"
            primary-button-class="is-danger"
            title="Redigera mottagarlista"
            method="post"
            :action="route('admin.mailshots.remove-selected', mailshot.id)"
            :redirect-to="route('admin.mailshots.show', mailshot.id)"
            width="1000"
        >
            <button
                class="btn btn-sm is-ghost"
                type="button"
                @click="invertCheckboxes"
            >
                Invertera val
            </button>
            <table class="table font-normal">
                <thead>
                    <tr>
                        <th>Index</th>
                        <th style="min-width: 300px;">Adress</th>
                        <th style="min-width: 300px;">Kund</th>
                        <th style="width: 100%;">Leveransstatus</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(reference, referenceIndex) in references">
                        <td>
                            <label style="cursor: pointer; white-space: nowrap;">
                                <input
                                    type="checkbox"
                                    name="recipient_ids[]"
                                    :value="reference.recipient_id"
                                >&nbsp;
                                <span class="italic">{{ referenceStartIndex + referenceIndex }}.</span>
                            </label>
                        </td>
                        <td>
                            <a :href="getAddressShowUrl(reference)">
                                {{ reference.street_name }}
                                {{ reference.street_number }}
                                {{ reference.street_letter }}
                                {{ reference.apartment_number }}
                            </a>
                        </td>
                        <td>
                            <a :href="getCustomerEditUrl(reference)">
                                {{ reference.customer_name ? reference.customer_name : '[KUND SAKNAS]' }}
                            </a>
                        </td>
                        <td>
                            {{ reference.delivery_status === '' ? '&mdash;' : reference.delivery_status }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            mailshot: {
                type: Object,
                required: true,
            },
            referenceStartIndex: {
                type: Number,
                required: false,
                default: 2,
            },
            references: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
            };
        },

        computed: {
        },

        methods: {
            getAddressShowUrl(reference) {
                return route('admin.sales-projects.addresses.show', { salesProject: reference.sales_project_id, address: reference.address_id });
            },
            getCustomerEditUrl(reference) {
                return reference.customer_name
                    ? route('admin.sales-projects.customers.edit', { sales_project: reference.sales_project_id, customer: reference.customer_id, address: reference.address_id })
                    : this.getAddressShowUrl(reference);
            },
            invertCheckboxes() {
                document.querySelectorAll('input[name="recipient_ids[]"]').forEach(c => c.checked = ! c.checked);
            },
        },
    };
</script>
